module.exports = __webpack_public_path__ + "img/bg-dapps-center.ff9e49a1.jpg";